export enum childType {
  Field = 'field',
  SubTitle = 'subTitle',
}

export interface IFields {
  type: string;
  fieldName?: string;
  title: string;
  value: string;
  order: number;
  view: boolean;
}

export interface IResultChildren {
  id: number;
  parentId: number;
  order: number;
  title: string;
  fields: IFields[];
}

export interface IResult {
  id: number;
  name: string;
  children: IResultChildren[];
}

export interface IResponse {
  totalCount: number;
  results: IResult[];
}
